var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"justify-center"},[_c('v-col',{attrs:{"cols":"12","sm":"11","md":"11","lg":"11","xl":"10"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }